export default {
  steps: {
    setup_fee: 'Opsætningsgebyr',
    business_info: 'Virksomhedsoplysninger',
    create_preview: 'Opret forhåndsvisning af kontrakt',
    preview: 'Forhåndsvis kontrakt',
    sign: 'Underskriv kontrakt',
  },
  buttons: {
    next: 'Forhåndsvis kontrakt',
    save_and_continue: 'Gem og fortsæt',
    update: 'Opdater forhåndsvisning',
    cancel: 'Annuller nuværende',
    skip: 'Spring oprettelse af kontrakt over',
  },
  create_preview: {
    header: 'Opret forhåndsvisning af kontrakt',
    description: 'Indtast modtagerens oplysninger til kontrakten. Du kan stadig ændre dem, før den sendes.',
  },
  sign: {
    update_notice: 'For at opdatere kontrakten skal du annullere den nuværende og redigere oplysningerne.',
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
  },
};
